import axios from "axios"
import { URL } from "./settings"

export default class DutyService {
    static async getDutySchedule(data) {
        try {
            const response = await axios.get(`${URL}/duty/`,
                {
                    withCredentials: true,
                    params: {
                        ...data
                    }
                }
            )
            console.log("DutyService::getDutySchedule response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async createDutySchedule(data) {
        try {
            const response = await axios.post(`${URL}/duty/`, 
                {
                    ...data,
                    base_count_manager: 10,
                    base_start_hour: 12,
                    base_start_minute: 0,
                    base_end_hour: 22,
                    base_end_minute: 0,
                    base_slots: 3
                },
                {
                    withCredentials: true
                }
            )
            console.log("DutyService::createDutySchedule response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async changeDutyUser(dutyTimeId, userId) {
        console.log('changeDutyUser:', dutyTimeId, userId)
        try {
            const response = await axios.patch(`${URL}/duty/select_duty_user`,
                {},
                {
                    withCredentials: true,
                    params: userId ? { duty_time_id: dutyTimeId, user_id: userId } : { duty_time_id: dutyTimeId }
                }
            )
            console.log("DutyService::changeDutyUser response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
}
